import { Reveal, Overline } from "@/components/site/Reveal";

const chapters = [
  { n: "01", t: "Built around one child", d: "We match every plan to your child's exact grade, board and core subjects, never a one-size-fits-all classroom." },
  { n: "02", t: "Small by design", d: "1-to-1 sessions or tiny batches mean questions get answered the moment they arise, not a week later." },
  { n: "03", t: "Assessment as a habit", d: "Every alternate week reserves a class for tests, evaluation and doubt-clearing so progress is measured, not assumed." },
  { n: "04", t: "In step with school", d: "Classes follow the school's prescribed syllabus and calendar to guarantee timely curriculum completion." },
];

export const Manifesto = () => (
  <section id="why" className="py-24 md:py-32 bg-primary text-primary-foreground relative overflow-hidden">
    <div className="noise absolute inset-0 opacity-[0.05] mix-blend-overlay pointer-events-none" />
    <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
      <Reveal>
        <Overline>Why alfabrains</Overline>
        <h2 className="font-heading font-bold text-4xl md:text-6xl tracking-tight max-w-3xl leading-[1.03]">
          Tutoring that respects your child's time, and your trust.
        </h2>
      </Reveal>

      <div className="grid md:grid-cols-2 gap-x-16 gap-y-12 mt-16">
        {chapters.map((c, i) => (
          <Reveal key={c.n} delay={0.06 * i}>
            <div className="flex gap-6 border-t border-white/15 pt-7">
              <span className="font-heading font-black text-5xl text-accent leading-none">{c.n}</span>
              <div>
                <h3 className="font-heading font-bold text-2xl">{c.t}</h3>
                <p className="text-white/75 mt-2 leading-relaxed">{c.d}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
